const TrueCheck = () => {
  return (
    <svg
      width="13"
      height="9"
      viewBox="0 0 13 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.49902 5.31348L3.53254 8.347C3.94259 8.75705 4.60741 8.75705 5.01746 8.347L11.726 1.63848C12.0406 1.32383 12.0406 0.813673 11.726 0.49902C11.4113 0.184367 10.9012 0.184365 10.5865 0.499019L4.94675 6.13879C4.57575 6.50979 3.97425 6.50979 3.60325 6.13879L1.63848 4.17402C1.32383 3.85937 0.813673 3.85937 0.49902 4.17402C0.184366 4.48867 0.184367 4.99883 0.49902 5.31348Z"
        fill="#7E50FF"
        stroke="#7E50FF"
        strokeWidth="0.1"
      />
    </svg>
  );
};

export default TrueCheck;
